export const KEYFRAMES = {
  FADE_SLIDE_IN: `@keyframes fadeSlideIn {
    from { opacity: 0; transform: translateY(-16px); }
    to { opacity: 1; transform: translateY(0); }
  }`,
} as const satisfies Record<keyof typeof ANIMATIONS, string>;

export const ANIMATIONS = {
  FADE_SLIDE_IN: "fadeSlideIn",
} as const;
